import Text from "@/ui/core/Text";
import { HStack, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface InputLabelProps extends ViewWithTestID {
  isOptional?: boolean;
  isRequired?: boolean;
  secondaryText?: string;
  tertiaryText?: string;
  text: string;
}

const InputLabel = ({
  isOptional,
  isRequired,
  secondaryText,
  tertiaryText,
  testID,
  text,
}: InputLabelProps) => (
  <VStack gap={4}>
    <HStack gap={6} justifyContent="space-between">
      <Text
        color={ColorToken.NeutralSecondary}
        testID={joinTestIDs(testID, "label")}
        variant="caption"
      >
        {text}
        {isRequired ? (
          <Text
            color={ColorToken.NotificationCritical}
            testID={joinTestIDs(testID, "required-indicator")}
            variant="caption"
          >
            {" *"}
          </Text>
        ) : (
          isOptional && (
            <Text
              color={ColorToken.NeutralTertiary}
              testID={joinTestIDs(testID, "optional-indicator")}
              variant="overline"
            >
              {" (optional)"}
            </Text>
          )
        )}
      </Text>
      {secondaryText ? (
        <Text
          color={ColorToken.NeutralSecondary}
          testID={joinTestIDs(testID, "sub-label")}
          variant="caption"
        >
          {secondaryText}
        </Text>
      ) : null}
    </HStack>
    {tertiaryText ? (
      <Text
        color={ColorToken.NeutralTertiary}
        testID={joinTestIDs(testID, "info")}
        variant="caption"
      >
        {tertiaryText}
      </Text>
    ) : null}
  </VStack>
);

export default InputLabel;
export type { InputLabelProps };
